import { render, staticRenderFns } from "./modal_estadoPersonal.vue?vue&type=template&id=000328e3&"
import script from "./modal_estadoPersonal.vue?vue&type=script&lang=js&"
export * from "./modal_estadoPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports